"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dragula_1 = __importDefault(require("react-dragula"));
// Generically typed by the exported functions
const DraggableContext = react_1.createContext(undefined);
const DrakeContext = react_1.createContext(undefined);
const InternalContext = react_1.createContext(undefined);
function useDraggableStore() {
    return react_1.useContext(DraggableContext);
}
const useInternalStore = () => react_1.useContext(InternalContext);
const useDrake = () => react_1.useContext(DrakeContext);
function Draggable(_a) {
    var { draggableStore } = _a, props = __rest(_a, ["draggableStore"]);
    const [internalStore, setInternalStore] = react_1.useState({
        isMouseOverHandle: false,
    });
    const itemRef = react_1.useCallback((node) => {
        if (node) {
            // eslint-disable-next-line no-param-reassign
            node.draggableStore = draggableStore;
            // eslint-disable-next-line no-param-reassign
            node.internalStore = internalStore;
        }
    }, [draggableStore, internalStore]);
    return (jsx_runtime_1.jsx(DraggableContext.Provider, Object.assign({ value: draggableStore }, { children: jsx_runtime_1.jsx(InternalContext.Provider, Object.assign({ value: { internalStore, setInternalStore } }, { children: jsx_runtime_1.jsx("div", Object.assign({ ref: itemRef }, props), void 0) }), void 0) }), void 0));
}
function useDragula({ onDrag, onDragEnd, onDrop, onCancel, onRemove, onShadow, onOver, onOut, onCloned, options, dependencyList, }) {
    const [drake, setDrake] = react_1.useState();
    const drakeRef = react_1.useCallback((node) => {
        if (node) {
            setDrake(react_dragula_1.default([...node.children], Object.assign(Object.assign({}, options), { isContainer(el) {
                    if (!options.isContainer)
                        return false;
                    return options.isContainer({ el });
                },
                moves(el, container, handle, sibling) {
                    if (!options.moves)
                        return true;
                    return options.moves({ el, container, handle, sibling });
                },
                accepts(el, target, handle, sibling) {
                    if (!options.accepts)
                        return true;
                    return options.accepts({ el, target, handle, sibling });
                },
                invalid(el, target) {
                    if (!options.invalid)
                        return false;
                    return options.invalid({ el, target });
                } }))
                .on("drag", function listener(el, source) {
                onDrag === null || onDrag === void 0 ? void 0 : onDrag({ el, source });
            })
                .on("dragend", function listener(el) {
                onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd({ el });
            })
                .on("drop", function listener(el, source, target, sibling) {
                onDrop === null || onDrop === void 0 ? void 0 : onDrop({ el, source, target, sibling });
            })
                .on("cancel", function listener(el, container, source) {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel({ el, container, source });
            })
                .on("remove", function listener(el, container, source) {
                onRemove === null || onRemove === void 0 ? void 0 : onRemove({ el, container, source });
            })
                .on("shadow", function listener(el, container, source) {
                onShadow === null || onShadow === void 0 ? void 0 : onShadow({ el, container, source });
            })
                .on("over", function listener(el, container, source) {
                onOver === null || onOver === void 0 ? void 0 : onOver({ el, container, source });
            })
                .on("out", function listener(el, container, source) {
                onOut === null || onOut === void 0 ? void 0 : onOut({ el, container, source });
            })
                .on("cloned", function listener(clone, original, type) {
                onCloned === null || onCloned === void 0 ? void 0 : onCloned({ clone, original, type });
            }));
        }
    }, [...dependencyList]);
    return { drake, drakeRef };
}
function DragulaContainer(_a) {
    var props = __rest(_a, []);
    return jsx_runtime_1.jsx("div", Object.assign({}, props), void 0);
}
function Dragula(_a) {
    var { onDrag, onDragEnd, onDrop, onCancel, onRemove, onShadow, onOver, onOut, onCloned, options = {}, dependencyList = [] } = _a, props = __rest(_a, ["onDrag", "onDragEnd", "onDrop", "onCancel", "onRemove", "onShadow", "onOver", "onOut", "onCloned", "options", "dependencyList"]);
    const { drake, drakeRef } = useDragula({
        onDrag,
        onDragEnd,
        onDrop,
        onCancel,
        onRemove,
        onShadow,
        onOver,
        onOut,
        onCloned,
        options,
        dependencyList,
    });
    return (jsx_runtime_1.jsx(DrakeContext.Provider, Object.assign({ value: drake }, { children: jsx_runtime_1.jsx("div", Object.assign({ ref: drakeRef }, props), void 0) }), void 0));
}
function DragulaHandle(_a) {
    var props = __rest(_a, []);
    const drake = useDrake();
    const { internalStore, setInternalStore } = useInternalStore();
    if (!drake)
        return null;
    return (jsx_runtime_1.jsx("div", Object.assign({ "aria-hidden": "true", onMouseEnter: () => setInternalStore(Object.assign(Object.assign({}, internalStore), { isMouseOverHandle: true })), onMouseLeave: () => setInternalStore(Object.assign(Object.assign({}, internalStore), { isMouseOverHandle: false })) }, props), void 0));
}
function initializeDragula() {
    return {
        Dragula: (props) => jsx_runtime_1.jsx(Dragula, Object.assign({}, props), void 0),
        DragulaContainer: (props) => (jsx_runtime_1.jsx(DragulaContainer, Object.assign({}, props), void 0)),
        Draggable: (props) => jsx_runtime_1.jsx(Draggable, Object.assign({}, props), void 0),
        DragulaHandle: (props) => jsx_runtime_1.jsx(DragulaHandle, Object.assign({}, props), void 0),
        useDraggableStore: () => useDraggableStore(),
        useInternalStore: () => useInternalStore(),
        useDrake: () => useDrake(),
    };
}
exports.default = initializeDragula;
